const PINCODE_STREETS = {
    '600015': {
        Saidapet: [
            'Jones Road',
            'Bazaar',
            'Alandur Road',
            'Taluk Office Road',
            'Karaneeswarar',
            'V.S. Mudali Street',
            'Venkatapuram Street',
            'Anna Street',
        ],
    },
};

function areaMatches(areaName, selectedLabel) {
    const area = String(areaName || '').trim().toLowerCase();
    const selected = String(selectedLabel || '').trim().toLowerCase();
    if (!area || !selected) {
        return false;
    }
    return selected.includes(area) || area.includes(selected);
}

export function areasForPincode(pincode) {
    const pin = String(pincode || '').trim();
    return Object.keys(PINCODE_STREETS[pin] || {}).map((name) => ({
        value: name,
        label: name,
        name,
    }));
}

export function streetsForPincodeArea(pincode, areaLabel) {
    const pin = String(pincode || '').trim();
    const groups = PINCODE_STREETS[pin] || {};
    const key = Object.keys(groups).find((area) => areaMatches(area, areaLabel));
    return (groups[key] || []).map((street) => ({
        value: street,
        label: street,
        name: street,
    }));
}

export function localitiesForPincode(pincode) {
    return areasForPincode(pincode);
}
